<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Control de acceso" />
        </div>

        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card" v-if="evento">
                            <div class="card-body">
                                <h4>{{ evento.nombre }}</h4>
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <span class="font-weight-bold">Autor:</span> {{ evento.autor }}
                                </li>
                                <li class="list-group-item">
                                    <span class="font-weight-bold">Inicio:</span> {{ evento.fecha_inicio }}
                                </li>
                                <li class="list-group-item">
                                    <span class="font-weight-bold">Fin:</span> {{ evento.fecha_fin }}
                                </li>
                                <li class="list-group-item">
                                    <span class="font-weight-bold">Código de evento:</span> {{ codigo_evento }}
                                </li>
                                <li class="list-group-item" v-if="puertas && precios">
                                    <div class="form-group">
                                        <label class="font-weight-bold">Puerta:</label>
                                        <multiselect
                                            v-model="selectedPuerta"
                                            :options="puertas"
                                            placeholder="Seleccionar puerta"
                                            label="nombre"
                                            track-by="id"
                                            :close-on-select="true"
                                            @select="getSesionInfo"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label class="font-weight-bold">Precio:</label>
                                        <multiselect
                                            v-model="precio"
                                            :options="precios"
                                            placeholder="Seleccionar precio"
                                            label="name"
                                            track-by="id"
                                            :close-on-select="true"
                                            @select="getSesionInfo"
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-6 mt-3" v-if="sesion && sesion.entradas_validadas !== null">
                        <div class="card border-success mb-3 justify-content-center">
                            <div class="card-header text-center">
                                Entradas validadas
                            </div>
                            <div class="card-body d-flex align-items-center justify-content-center text-success">
                                <h5 class="card-title" :style="{ fontSize: esMovil ? '50px' : '100px' }">{{ sesion.entradas_validadas }}</h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 mt-3" v-if="sesion && sesion.entradas_vendidas != null">
                        <div class="card border-danger mb-3 justify-content-center">
                            <div class="card-header text-center">
                                Entradas pendientes de validación
                            </div>
                            <div class="card-body d-flex align-items-center justify-content-center text-danger">
                                <h5 class="card-title" :style="{ fontSize: esMovil ? '50px' : '100px' }">{{ sesion.entradas_vendidas - sesion.entradas_validadas }}</h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mt-3">
                        <div class="card">
                            <div class="card-body">
                                <h4>Escanear código QR</h4>

                                <div class="form-group mt-3">
                                    <div class="custom-control custom-radio mr-4">
                                        <input
                                            type="radio"
                                            id="validar"
                                            name="accion"
                                            value="validar"
                                            class="custom-control-input"
                                            v-model="accion_qr"
                                        />
                                        <label for="validar" class="custom-control-label">Validar entradas</label>
                                    </div>
                                    <div class="custom-control custom-radio mr-4">
                                        <input
                                            type="radio"
                                            id="reactivar"
                                            name="accion"
                                            value="reactivar"
                                            class="custom-control-input"
                                            v-model="accion_qr"
                                        />
                                        <label for="reactivar" class="custom-control-label">Reactivar entradas</label>
                                    </div>
                                    <div class="custom-control custom-radio mr-4">
                                        <input
                                            type="radio"
                                            id="validar-productos"
                                            name="accion"
                                            value="validar-productos"
                                            class="custom-control-input"
                                            v-model="accion_qr"
                                        />
                                        <label for="validar-productos" class="custom-control-label">Validar productos</label>
                                    </div>
                                    <div class="custom-control custom-radio mr-4">
                                        <input
                                            type="radio"
                                            id="reactivar-productos"
                                            name="accion"
                                            value="reactivar-productos"
                                            class="custom-control-input"
                                            v-model="accion_qr"
                                        />
                                        <label for="reactivar-productos" class="custom-control-label">Reactivar productos</label>
                                    </div>
                                </div>
                                <ModalProductosQr
                                    name="productos-qr"
                                    :codigo_evento="codigo_evento"
                                    :sesion_id="sesion_id"
                                    :qr_code="codigoQr"
                                    :accion_qr="accion_qr"
                                    @confirm="checkAccion"
                                    @close="closeModal"
                                />

                                <div class="form-group">
                                    <label for="codigo">Código {{ accion_qr.includes('productos') ? 'producto' : 'entrada' }}</label>
                                    <input type="text" autofocus id="codigo" v-model="codigoQr" />
                                </div>

                                <div v-if="respuestaQr !== null">
                                    <div
                                        v-if="respuestaQr.error == true"
                                        role="alert"
                                        class="alert alert-danger"
                                        style="font-size: 50px; font-weight: bold;"
                                    >
                                        {{ respuestaQr.mensaje }}
                                    </div>
                                    <div
                                        v-if="respuestaQr.error == false"
                                        role="alert"
                                        class="alert alert-success"
                                        style="font-size: 50px; font-weight: bold;"
                                    >
                                        {{ respuestaQr.mensaje }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Gestión de entradas y abonados -->
                    <div class="col-12 mt-3">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-right mt-3" v-if="activeTab == 'entradas'">
                                    <button @click="showModal('Reactivar-entradas')" class="btn btn-primary">
                                        Reactivar Entradas
                                    </button>
                                </div>
                                <div class="text-right mt-3" v-if="activeTab == 'abonados'">
                                    <button @click="showModal('Reactivar-abonados')" class="btn btn-primary">
                                        Reactivar Abonados
                                    </button>
                                </div>

                                <ModalActivar
                                    v-if="activeTab == 'entradas'"
                                    name="entradas"
                                    title="Reactivar entradas"
                                    confirmButton="Activar"
                                    :codigo_evento="codigo_evento"
                                    @confirm="reactivarEntradas"
                                    @close="closeModal"
                                />

                                <ModalActivar
                                    v-if="activeTab == 'abonados'"
                                    name="abonados"
                                    title="Reactivar abonados"
                                    confirmButton="Activar"
                                    :codigo_evento="codigo_evento"
                                    @confirm="reactivarAbonos"
                                    @close="closeModal"
                                />

                                <div class="row">
                                    <div class="col-12">
                                        <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                                            <li class="nav-item">
                                                <a
                                                    :class="activeTab == 'entradas' ? 'nav-link active' : 'nav-link'"
                                                    @click.prevent="activeTab = 'entradas'"
                                                    href="#"
                                                >
                                                    Entradas
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    id="nav-profile-tab"
                                                    :class="activeTab == 'abonados' ? 'nav-link active' : 'nav-link'"
                                                    @click="activeTab = 'abonados'"
                                                    data-toggle="tab"
                                                    href="#abonados"
                                                    role="tab"
                                                >
                                                    Abonados
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    id="nav-profile-tab"
                                                    :class="activeTab == 'productos' ? 'nav-link active' : 'nav-link'"
                                                    @click="activeTab = 'productos'"
                                                    data-toggle="tab"
                                                    href="#productos"
                                                    role="tab"
                                                >
                                                    Productos
                                                </a>
                                            </li>
                                        </ul>

                                        <div class="tab-content pt-3">
                                            <div v-if="activeTab === 'entradas'">
                                                <div class="col-12">
                                                    <div class="form-group pt-3">
                                                        <label for="buscar">Buscar</label>
                                                        <input type="text" id="buscar" v-model="buscarEntrada" />
                                                    </div>
                                                    <div class="table-responsive py-3" v-if="entradas">
                                                        <b-table hover :items="entradas.data" :fields="fieldsEntradas">
                                                            <template #cell(estado)="data">
                                                                <span v-if="data.item.estado == 0">No validado</span>
                                                                <span v-else>Validado</span>
                                                            </template>

                                                            <template #cell(opciones)="{ item }">
                                                                <OpcionesDropdownComponent
                                                                    :options="[
                                                                        { type: 'action', action: () => validarQr(item.qr_code), label: 'Validar', visible: item.estado == 0 },
                                                                        { type: 'action', action: () => reactivarQr(item.qr_code), label: 'Reactivar', visible: item.estado != 0 }
                                                                    ]"
                                                                />
                                                            </template>
                                                        </b-table>
                                                    </div>
                                                    <div class="row justify-content-between" v-if="entradas">
                                                        <div class="col-12 col-lg-3">
                                                            <ElementosPorPaginaComponent
                                                                v-model="entradas.meta.per_page"
                                                                @input="getEntradas"
                                                            />
                                                        </div>
                                                        <div class="col-12 col-lg-4">
                                                            <PaginateComponent
                                                                :current_page="entradas.meta.current_page"
                                                                :last_page="entradas.meta.last_page"
                                                                @change_page="setPageEntrada"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tab de Abonados -->
                                            <div v-if="activeTab === 'abonados'">
                                                <div class="col-12">
                                                    <div class="form-group pt-3">
                                                        <label for="buscar">Buscar</label>
                                                        <input
                                                            type="text"
                                                            id="buscar"
                                                            class="form-control"
                                                            v-model="buscarAbonado"
                                                        />
                                                    </div>
                                                    <div class="table-responsive py-3" v-if="abonados">
                                                        <b-table hover :items="abonados.data" :fields="fieldsAbonados">
                                                            <template #cell(estado)="data">
                                                                <span v-if="data.item.estado == 0">No validado</span>
                                                                <span v-else>Validado</span>
                                                            </template>

                                                            <template #cell(opciones)="{ item }">
                                                                <OpcionesDropdownComponent
                                                                    :options="[
                                                                        { type: 'action', action: () => validarQr(item.qr_code), label: 'Validar', visible: item.estado == 0 },
                                                                        { type: 'action', action: () => reactivarQr(item.qr_code), label: 'Reactivar', visible: item.estado != 0 }
                                                                    ]"
                                                                />
                                                            </template>
                                                        </b-table>
                                                    </div>
                                                    <div class="row justify-content-between" v-if="abonados">
                                                        <div class="col-12 col-lg-3">
                                                            <ElementosPorPaginaComponent
                                                                v-model="abonados.meta.per_page"
                                                                @input="getAbonos"
                                                            />
                                                        </div>
                                                        <div class="col-12 col-lg-4">
                                                            <PaginateComponent
                                                                :current_page="abonados.meta.current_page"
                                                                :last_page="abonados.meta.last_page"
                                                                @change_page="setPageAbono"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tab de productos -->
                                            <div v-if="activeTab === 'productos'">
                                                <div class="col-12">
                                                    <div class="form-group pt-3">
                                                        <label for="buscar">Buscar</label>
                                                        <input
                                                            type="text"
                                                            id="buscar"
                                                            class="form-control"
                                                            v-model="buscarPedido"
                                                        />
                                                    </div>
                                                    <template v-if="!loading">
                                                        <div class="table-responsive py-3" v-if="pedidos">
                                                            <b-table hover :items="pedidos.data" :fields="fieldsPedidos">
                                                                <template #cell(opciones)="{ item }">
                                                                    <OpcionesDropdownComponent
                                                                        :options="[ 
                                                                            { type: 'action', action: () => showModal('productos-a-validar', item.productos.filter(producto => !producto.hora_recogida), item.qr_code), label: 'Validar productos', visible: item.productos.some(producto => !producto.hora_recogida) },
                                                                            { type: 'action', action: () => showModal('productos-a-reactivar', item.productos.filter(producto => producto.hora_recogida), item.qr_code), label: 'Reactivar productos', visible: item.productos.some(producto => producto.hora_recogida) }
                                                                        ]"
                                                                    />
                                                                </template>
                                                            </b-table>
                                                            <ModalValidarProductos
                                                                name="productos-a-validar"
                                                                :qr_code="qr_code_pedido"
                                                                :productos="productosSeleccionados"
                                                                @validarProductos="validarProductos"
                                                                @close="closeModal"
                                                            />
                                                            <ModalReactivarProductos
                                                                name="productos-a-reactivar"
                                                                :qr_code="qr_code_pedido"
                                                                :productos="productosSeleccionados"
                                                                @reactivarProductos="reactivarProductos"
                                                                @close="closeModal"
                                                            />
                                                        </div>
                                                        <div class="row justify-content-between" v-if="pedidos">
                                                            <div class="col-12 col-lg-3">
                                                                <ElementosPorPaginaComponent
                                                                    @input="getPedidos"
                                                                    v-model="pedidos.meta.per_page"
                                                                />
                                                            </div>
                                                            <div class="col-12 col-lg-4">
                                                                <PaginateComponent
                                                                    :current_page="pedidos.meta.current_page"
                                                                    :last_page="pedidos.meta.last_page"
                                                                    @change_page="setPagePedido"
                                                                />
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <LoaderComponent v-else />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import ElementosPorPaginaComponent from './ElementosPorPaginaComponent';
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
    import axios from 'axios';
    import ModalActivar from './ModalActivar.vue';
    import AlertSound from '@/assets/sounds/Alert_sound.mp3';
    import SucessSound from '@/assets/sounds/Success_sound.mp3';
    const BASE_URL = 'https://control-acceso.compralaentrada.com/api';
    const AlertAudio = new Audio(AlertSound);
    const SuccessAudio = new Audio(SucessSound);
    import ModalProductosQr from '@/components/backend/eventos/sesiones/control-acceso/modals/ModalProductosQr.vue';
    import ModalValidarProductos from '@/components/backend/eventos/sesiones/control-acceso/modals/ModalValidarProductos.vue';
    import ModalReactivarProductos from '@/components/backend/eventos/sesiones/control-acceso/modals/ModalReactivarProductos.vue';

    export default {
        props: ['evento_id', 'sesion_id', 'codigo_evento'],
        data() {
            return {
                evento: null,
                puertas: null,
                sesion: null,
                precios: null,
                precio: null,
                accion_qr: 'validar',
                codigoQr: '',
                selectedPuerta: null,
                buscarEntrada: null,
                buscarAbonado: null,
                buscarPedido: null,
                respuestaQr: null,
                entradas: null,
                abonados: null,
                pedidos: null,
                activeTab: 'entradas',
                reload: 1,
                productosSeleccionados: [],
                qr_code_pedido: null,
                loading: false,
                fieldsEntradas: [
                    { key: 'qr_code', label: 'Localizador' },
                    { key: 'datos_comprador.nombre', label: 'Nombre' },
                    { key: 'datos_comprador.apellidos', label: 'Apellidos' },
                    { key: 'datos_comprador.dni', label: 'DNI' },
                    { key: 'region', label: 'Región' },
                    { key: 'fila', label: 'Fila' },
                    { key: 'butaca', label: 'Butaca' },
                    { key: 'estado', label: 'Estado' },
                    { key: 'opciones', label: 'Opciones' },
                ],
                fieldsAbonados: [
                    { key: 'qr_code', label: 'Localizador' },
                    { key: 'n_abonado', label: 'Nº abonado' },
                    { key: 'name', label: 'Nombre' },
                    { key: 'surnames', label: 'Apellidos' },
                    { key: 'dni', label: 'DNI' },
                    { key: 'email', label: 'Email' },
                    { key: 'estado', label: 'Estado' },
                    { key: 'opciones', label: 'Opciones' },
                ],
                fieldsPedidos: [
                    { key: 'qr_code', label: 'Localizador', class: 'text-center' },
                    { key: 'tpv_order', label: 'N de pedido', class: 'text-center' },
                    { key: 'email', label: 'Email', class: 'text-center' },
                    { key: 'opciones', label: 'Opciones', class: 'text-center' },
                ]
            };
        },
        created() {
            this.getEvento();
            this.getPuertas();
            this.getSesionInfo();
            this.getPreciosEntradas();
            this.getEntradas();
            this.getPedidos();
            this.getAbonos();
            this.debouncedEscanearQr = _.debounce(this.escanearQr, 1900);
            this.debouncedBuscarEntrada = _.debounce(this.getEntradas, 1900);
            this.debouncedBuscarPedido = _.debounce(this.getPedidos, 500);
            this.debouncedBuscarAbono = _.debounce(this.getAbonos, 1900);
        },
        watch: {
            codigoQr(newVal) {
                if (newVal.trim() !== '') {
                    this.debouncedEscanearQr();
                }
            },
            buscarAbonado(newVal) {
                this.debouncedBuscarAbono();
            },
            buscarEntrada(newVal) {
                this.debouncedBuscarEntrada();
            },
            buscarPedido(newVal) {
                this.debouncedBuscarPedido();
            },
            accion_qr() {
                if (this.codigoQr) {
                    this.debouncedEscanearQr();
                }
            }
        },
        methods: {
            async getPedidos() {
                this.loading = true;

                const params = {};

                if (this.pedidos) {
                    params.page = this.pedidos.meta.current_page;
                    params.per_page = this.pedidos.meta.per_page;
                }

                if (this.buscarPedido) {
                    params.search = this.buscarPedido;
                }

                try {
                    const response = await axios.get(
                        `https://control-acceso.dev.compralaentrada.com/api/eventos/02802/sesiones/168/productos`,
                        { params }
                    );
                    this.pedidos = response.data;
                    this.loading = false;
                } catch (error) {
                    console.error("Error:", error);
                    this.loading = false;
                }
            },
            async getEvento() {
                try {
                    const response = await axios.get(`${BASE_URL}/eventos/${this.codigo_evento}`);
                    this.evento = response.data.evento;
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async getPuertas() {
                try {
                    const response = await axios.get(`${BASE_URL}/eventos/${this.codigo_evento}/puertas`);
                    if (response.data.puertas) {
                        this.puertas = [{ id: '', nombre: 'Ninguna puerta seleccionada' }, ...response.data.puertas];
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async getSesionInfo() {
                const params = {};

                if (this.selectedPuerta) {
                    params.puerta = this.selectedPuerta.id;
                }
                if (this.precio) {
                    params.precio = this.precio.id;
                }

                try {
                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}`,
                        { params }
                    );
                    this.sesion = response.data.data;
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async getPreciosEntradas() {
                try {
                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/entradas/precios`
                    );
                    if (response.data.data) {
                        this.precios = [{ id: '', name: 'Ningún precio seleccionado' }, ...response.data.data];
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async validarQr(codigoQrTabla) {
                try {
                    const params = {};

                    if (this.selectedPuerta && this.selectedPuerta.id) {
                        params.puerta = this.selectedPuerta.id;
                    }

                    if (this.precio && this.precio.id) {
                        params.precio = this.precio.id;
                    }

                    const codigo = this.codigoQr || codigoQrTabla;
                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/${codigo}/validar`,
                        { params }
                    );
                    this.respuestaQr = response.data;
                    this.codigoQr = '';

                    if (response.data.error) {
                        AlertAudio.play();
                    } else {
                        this.respuestaQr.mensaje = 'Validada';
                        this.getEntradas();
                        this.getAbonos();
                        this.getSesionInfo();
                        SuccessAudio.play();
                    }

                    setTimeout(() => {
                        this.respuestaQr = null;
                    }, 3000);
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            checkAccion(productos, modalName) {
                if (this.accion_qr === 'validar-productos') {
                    this.validarProductos(productos, modalName)
                } else if (this.accion_qr === 'reactivar-productos') {
                    this.reactivarProductos(productos, modalName)
                }
            },
            async validarProductos(productos, modalName) {
                try {
                    const qr_code = productos[0].qr_code;
                    const productosIDs = productos.map(producto => producto.id);

                    await axios.post(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/productos/${qr_code}/validar`,
                        { productosIDs: productosIDs }
                    );

                    if(productosIDs.length > 0) {
                        this.$toast.success('Productos validados correctamente');
                    } else {
                        this.$toast.success('Producto validado correctamente');
                    }
                    this.getPedidos();

                    this.closeModal(modalName);
                } catch (error) {
                    this.$toast.error(error.response?.data?.mensaje);
                    console.error("Error:", error);
                }
            },
            async reactivarProductos(productos, modalName) {
                try {
                    const qr_code = productos[0].qr_code;
                    const productosIDs = productos.map(producto => producto.id);

                    await axios.post(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/productos/${qr_code}/reactivar`,
                        { productosIDs: productosIDs }
                    );

                    if(productosIDs.length > 0) {
                        this.$toast.success('Productos reactivados correctamente');
                    } else {
                        this.$toast.success('Producto reactivado correctamente');
                    }
                    this.getPedidos();

                    this.closeModal(modalName);
                } catch (error) {
                    this.$toast.error(error.response?.data?.mensaje);
                    console.error("Error:", error);
                }
            },
            async reactivarQr(codigoQrTabla) {
                try {
                    const params = {};

                    if (this.selectedPuerta && this.selectedPuerta.id) {
                        params.puerta = this.selectedPuerta.id;
                    }

                    if (this.precio && this.precio.id) {
                        params.precio = this.precio.id;
                    }

                    const codigo = this.codigoQr || codigoQrTabla;
                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/${codigo}/reactivar`,
                        { params }
                    );
                    this.respuestaQr = response.data;
                    this.codigoQr = '';

                    if (response.data.error) {
                        AlertAudio.play();
                    } else {
                        this.respuestaQr.mensaje = 'Reactivada';
                        this.getEntradas();
                        this.getAbonos();
                        this.getSesionInfo();
                        SuccessAudio.play();
                    }

                    setTimeout(() => {
                        this.respuestaQr = null;
                    }, 3000);
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async escanearQr() {
                if (this.accion_qr === 'validar-productos' || this.accion_qr === 'reactivar-productos') {
                    this.showModal('productos-qr');
                } else if (this.accion_qr === 'validar') {
                    this.validarQr();
                } else {
                    this.reactivarQr();
                }
            },
            async reactivarEntradas() {
                try {
                    await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/entradas/reactivar`
                    );
                    this.closeModal('Reactivar-entradas');
                    this.$toast.success('Entradas reactivadas con éxito');
                    this.getEntradas();
                    this.getSesionInfo();
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async reactivarAbonos() {
                try {
                    await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/abonos/reactivar`
                    );
                    this.closeModal('Reactivar-abonados');
                    this.$toast.success('Abonados reactivados con éxito');
                    this.getAbonos();
                    this.getSesionInfo();
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async getEntradas() {
                try {
                    const params = {};

                    if (this.entradas) {
                        params.page = this.entradas.meta.current_page;
                        params.per_page = this.entradas.meta.per_page;
                    }

                    if (this.buscarEntrada) {
                        params.search = this.buscarEntrada;
                    }

                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/entradas`,
                        { params }
                    );
                    this.entradas = response.data;
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            async getAbonos() {
                try {
                    const params = {};

                    if (this.abonados) {
                        params.page = this.abonados.meta.current_page;
                        params.per_page = this.abonados.meta.per_page;
                    }
                    if (this.buscarAbonado) {
                        params.search = this.buscarAbonado;
                    }

                    const response = await axios.get(
                        `${BASE_URL}/eventos/${this.codigo_evento}/sesiones/${this.sesion_id}/abonos`,
                        { params }
                    );
                    this.abonados = response.data;
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            setPageEntrada(page) {
                this.entradas.meta.current_page = page;
                this.getEntradas();
            },
            setPageAbono(page) {
                this.abonados.meta.current_page = page;
                this.getAbonos();
            },
            setPagePedido(page) {
                this.getPedidos();
                this.pedidos.meta.current_page = page;
            },
            showModal(modal, productos = null, qr_code = null) {
                if (productos && qr_code) {
                    this.productosSeleccionados = productos;
                    this.qr_code_pedido = qr_code;
                }

                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        components: {
            PageTitleComponent,
            PaginateComponent,
            ElementosPorPaginaComponent,
            OpcionesDropdownComponent,
            ModalActivar,
            ModalProductosQr,
            ModalValidarProductos,
            ModalReactivarProductos
        },
    };
</script>
